/* ROLES */
export const GET_SEASON_PASSES = "GET_SEASON_PASSES"
export const GET_SEASON_PASSES_SUCCESS = "GET_SEASON_PASSES_SUCCESS"
export const GET_SEASON_PASS_FAIL = "GET_SEASON_PASS_FAIL"

/* ROLES DETAIL*/
export const GET_SEASON_PASS_DETAIL = "GET_SEASON_PASS_DETAIL"
export const GET_SEASON_PASS_DETAIL_SUCCESS = "GET_SEASON_PASS_DETAIL_SUCCESS"
export const GET_SEASON_PASS_DETAIL_FAIL = "GET_SEASON_PASS_DETAIL_FAIL"

/**
 * ADD ROLE
 */
export const ADD_NEW_SEASON_PASS = "ADD_NEW_SEASON_PASS"
export const ADD_SEASON_PASS_SUCCESS = "ADD_SEASON_PASS_SUCCESS"
export const ADD_SEASON_PASS_FAIL = "ADD_SEASON_PASS_FAIL"

/**
 * EDIT ROLE
 */
export const UPDATE_SEASON_PASS = "UPDATE_SEASON_PASS"
export const UPDATE_SEASON_PASS_SUCCESS = "UPDATE_SEASON_PASS_SUCCESS"
export const UPDATE_SEASON_PASS_FAIL = "UPDATE_SEASON_PASS_FAIL"

/**
 * Delete user
 */
export const DELETE_SEASON_PASS = "DELETE_SEASON_PASS"
export const DELETE_SEASON_PASS_SUCCESS = "DELETE_SEASON_PASS_SUCCESS"
export const DELETE_SEASON_PASS_FAIL = "DELETE_SEASON_PASS_FAIL"

/**
 * CLEAR MESSAGE AND ERROR OBJECT
 */
export const CLEAR_MESSAGE = "CLEAR_MESSAGE"
